export default __webpack_public_path__ + "static/media/arrow.3387658d.svg";